import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ListDashboardprogressSlice = createSlice({
  name: "ListDashboardprogressSlice",
  initialState: {} as IReduxState<[]>,
  reducers: {
    listDashboardprogress: (state) => {
      state.isLoading = true;
    },
    successlistDashboardprogress: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistDashboardprogress: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistDashboardprogress,
  listDashboardprogress,
  successlistDashboardprogress,
} = ListDashboardprogressSlice.actions;

export default ListDashboardprogressSlice.reducer;
